export const getDaysSince = (target_date: string) => {
  return Math.ceil(
    (new Date().getTime() - new Date(target_date).getTime()) / (1000 * 60 * 60 * 24),
  );
};
